import * as actionTypes from '../actionTypes';
import initialState from './contactInfo.initialState';

const contactDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_ABOUT_YOURSELF_FORM:
      return {
        ...state,
        ...(action?.data || {}),
        aboutYourselfAvailable: true,
      };

    case actionTypes.VERIFY_EMAIL_MANUAL:
      return {
        ...state,
        isManual: action?.data || '',
        response: action.response?.data || {},
      };

    case actionTypes.VALIDATE_MOBILE_NO:
      return {
        ...state,
        phoneAPiResponse: action.response,
      };

    default:
      return state;
  }
};

export default contactDetailsReducer;
